<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_hr'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end ">
                <router-link
                  :to="{ path: '/schooldepartments' }"
                  type="button"
                  class="btn-sm btn btn-info mx-2"
                >
                  <i class="mdi mdi-account-lock"></i> Departments</router-link
                >
                <router-link
                  :to="{ path: '/positions' }"
                  type="button"
                  class="btn-sm btn btn-success mx-2"
                >
                  <i class="mdi mdi-account-lock"></i> Staff
                  Positions</router-link
                >
                <b-button v-b-modal.new-staffmember size="sm" variant="primary"
                  ><i class="mdi mdi-plus "></i> New Staff Member</b-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onTableFiltered"
                  :busy="IsBusy"
                >
                  <template #table-busy>
                    <NoDataMessage :type="emptyStateType" />
                  </template>
                  <strong>No Data Found</strong>
                  <!-- </template
                  > -->
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(full_name)="data"
                    >{{ data.item.full_name }} <br /><small style="color:red;"
                      >Card No: <b>{{ data.item.cardnumber }}</b></small
                    >
                  </template>
                  <template #cell(gender)="data">
                    <b
                      ><small>{{ data.item.dateofbirth }}</small></b
                    ><br />
                    {{ data.item.gender }}
                  </template>
                  <template #cell(email)="data">
                    <b
                      ><small>{{ data.item.email }}</small></b
                    ><br />
                    {{ data.item.contact }}
                  </template>
                  <template #cell(position)="data">
                    <small
                      ><b>{{ data.item.position.name }}</b></small
                    >
                  </template>
                  <template #cell(department)="data">
                    <small
                      ><b>{{ data.item.department.name }}</b></small
                    >
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <span v-if="data.item.status == 1">
                        <b-button
                          @click="
                            enrollmember(data.item.id, data.item.full_name)
                          "
                          type="button"
                          class="btn-sm btn"
                          variant="info"
                        >
                          <i class="mdi mdi-account-lock"></i>
                        </b-button>
                      </span>
                      <span v-else>
                        <b-button
                          type="button"
                          class="btn-sm btn"
                          variant="success"
                          ><i class="mdi mdi-check"></i
                        ></b-button>
                      </span>
                      <b-button
                        @click="
                          edit(
                            data.item.id,
                            data.item.full_name,
                            data.item.contact,
                            data.item.email,
                            data.item.gender,
                            data.item.nin,
                            data.item.dateofbirth,
                            data.item.address,
                            data.item.department.id,
                            data.item.position.id,
                            data.item.salary,
                            data.item.cardnumber,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="remove(data.item.id, data.item.full_name)"
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-staffmember"
        centered
        title="New Staff Member"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addStaffMember">
          <div class="form-group">
            <label>Staff Name</label>
            <input v-model="fullname" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label>Contact</label>
            <input v-model="contact" type="number" class="form-control" />
          </div>
          <div class="form-group">
            <label>Email Address</label>
            <input v-model="email" type="email" class="form-control" />
          </div>
          <div class="form-group">
            <label>National ID</label>
            <input v-model="nin" type="text" class="form-control" />
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Gender</label>
              <select class="form-control" v-model="gender"
                ><option>Male</option
                ><option>Female</option></select
              >
            </div>
            <div class="form-group col-md-6">
              <label>Date of Birth</label>
              <input
                v-model="dateofbirth"
                type="date"
                :max="currentdate"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group">
            <label>Address</label>
            <input v-model="address" type="text" class="form-control" />
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Department</label>
              <b-form-select
                v-model="department"
                :options="schooldepartments"
                class="form-control"
                value-field="id"
                text-field="name"
              ></b-form-select>
            </div>
            <div class="form-group col-md-6">
              <label>Position</label>
              <b-form-select
                v-model="position"
                :options="staffpositions"
                class="form-control"
                value-field="id"
                text-field="name"
              ></b-form-select>
            </div>
          </div>
          <div class="form-group">
            <label>Salary</label>
            <input v-model="salary" type="number" class="form-control" />
          </div>
          <b-form-group label="Card Number">
            <b-form-input
              v-model="cardnumber"
              type="text"
              placeholder="Enter Card Number"
            ></b-form-input>
          </b-form-group>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-staffmember')"
              >Close</b-button
            >
            <b-button
              type="submit"
              :disabled="btnuser"
              class="btn ms-1 w-30"
              variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-staffmember"
        centered
        title="Edit Staff Member"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editStaffMember">
          <div class="form-group">
            <input v-model="id" type="hidden" />
            <label>Staff Name</label>
            <input v-model="fullname" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label>Contact</label>
            <input v-model="contact" type="number" class="form-control" />
          </div>
          <div class="form-group">
            <label>Email Address</label>
            <input v-model="email" type="email" class="form-control" />
          </div>
          <div class="form-group">
            <label>National ID</label>
            <input v-model="nin" type="text" class="form-control" />
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Gender</label>
              <select class="form-control" v-model="gender"
                ><option>Male</option
                ><option>Female</option></select
              >
            </div>
            <div class="form-group col-md-6">
              <label>Date of Birth</label>
              <input v-model="dateofbirth" type="date" class="form-control" />
            </div>
          </div>
          <div class="form-group">
            <label>Address</label>
            <input v-model="address" type="text" class="form-control" />
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Department</label>
              <b-form-select
                v-model="department"
                :options="schooldepartments"
                class="form-control"
                value-field="id"
                text-field="name"
              ></b-form-select>
            </div>
            <div class="form-group col-md-6">
              <label>Position</label>
              <b-form-select
                v-model="position"
                :options="staffpositions"
                class="form-control"
                value-field="id"
                text-field="name"
              ></b-form-select>
            </div>
          </div>
          <div class="form-group">
            <label>Salary</label>
            <input v-model="salary" type="number" class="form-control" />
            <label>Card Number</label>
            <b-form-input
              v-model="cardnumber"
              class="form-control"
              type="text"
              placeholder="Enter Card Number"
            ></b-form-input>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-staffmember')"
              >Close</b-button
            >
            <b-button
              type="submit"
              :disabled="btnuser"
              class="btn ms-1 w-30"
              variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="enroll-staffmember"
        centered
        title="Enroll Staff Member"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="editStaffMemberPassword">
          <input v-model="id" type="hidden" />
          <div class="form-group">
            <label
              >Username for <b>{{ fullname }}</b></label
            >
            <span class="float-end" v-html="usernameerror"></span>
            <input
              v-model="username"
              type="text"
              @input="CheckUsername"
              class="form-control"
            />
          </div>
          <div class="form-group mb-2">
            <label>Password</label> <span v-html="passStrength"></span>
            <input
              v-model="password"
              type="password"
              @input="CheckPassword"
              class="form-control"
            />
          </div>
          <div class="form-group mb-2">
            <label>Role</label>
            <b-form-select
              v-model="role"
              :options="roles"
              class="mb-3 form-control"
              value-field="id"
              text-field="name"
            ></b-form-select>
          </div>
          <!-- <small class="text-danger"><i>Default password: <b>123456</b></i></small> -->
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('enroll-staffmember')"
              >Close</b-button
            >
            <b-button
              type="submit"
              :disabled="btnuser"
              class="btn ms-1 w-30"
              variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-staffmember"
        centered
        title="Delete Staff Member"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeStaffMember">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the StaffMember :
          <b>{{ fullname }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-staffmember')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>
      <div class="row">
        <h4>
          Total Staff Members : <b class="text-primary"> {{ staffCount }} </b>
        </h4>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import NoDataMessage from "@/components/NoDataMessage.vue";
import { emptyStatesMixin } from "@/state/emptyStatesMixin";
import {
  positionComputed,
  positionMethods,
  roleComputed,
  roleMethods,
  schooldepartmentComputed,
  schooldepartmentMethods,
  staffmemberComputed,
  staffmemberMethods,
} from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  mixins: [emptyStatesMixin],
  page: {
    title: "Staff Members",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    NoDataMessage,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Staff Members",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Staff Members", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "full_name", label: "Staff Name", visible: true },
        { key: "email", label: "Email Address", visible: true },
        { key: "gender", label: "Gender", visible: true },
        { key: "address", label: "Address", visible: true },
        { key: "nin", label: "National ID", visible: true },
        { key: "department", label: "Department", visible: true },
        { key: "position", label: "Position", visible: true },
        { key: "salary", label: "Salary", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      fullname: "",
      cardnumber: "",
      contact: "",
      email: "",
      department: "",
      dateofbirth: "",
      gender: "",
      address: "",
      position: "",
      nin: "",
      role: "",
      salary: 0,
      username: "",
      usernameerror: "",
      password: "",
      btnuser: false,
      totalstaff: 0,
      currentdate: new Date().toLocaleDateString("fr-CA"),
    };
  },
  computed: {
    ...staffmemberComputed,
    ...schooldepartmentComputed,
    ...roleComputed,
    ...positionComputed,
    List() {
      return this.staffmembers.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.staffmembers.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.staffmembers.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    staffCount() {
      return this.staffmembers.length;
    },
  },
  mounted() {
    this.fetchStaffMembers();
    this.fetchSchoolDepartments();
    this.fetchRoles();
    this.fetchStaffPositions();
    this.TotalRows = this.staffmembers.length;
    this.isBusy = false;
  },
  methods: {
    ...staffmemberMethods,
    ...schooldepartmentMethods,
    ...roleMethods,
    ...positionMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(
      id,
      fullname,
      contact,
      email,
      gender,
      nin,
      dateofbirth,
      address,
      department,
      position,
      salary,
      cardnumber,
    ) {
      this.id = id;
      this.fullname = fullname;
      this.contact = contact;
      this.email = email;
      this.gender = gender;
      this.nin = nin;
      this.dateofbirth = dateofbirth;
      this.address = address;
      this.department = department;
      this.position = position;
      this.salary = salary;
      this.cardnumber = cardnumber;
      this.$bvModal.show("edit-staffmember");
    },
    enrollmember(id, fullname) {
      this.id = id;
      this.fullname = fullname;
      this.$bvModal.show("enroll-staffmember");
    },
    remove(id, fullname) {
      this.id = id;
      this.fullname = fullname;
      this.$bvModal.show("delete-staffmember");
    },
    async addStaffMember() {
      let formData = new FormData();
      formData.append("fullname", this.fullname);
      formData.append("contact", this.contact);
      formData.append("email", this.email);
      formData.append("gender", this.gender);
      formData.append("address", this.address);
      formData.append("dateofbirth", this.dateofbirth);
      formData.append("nin", this.nin);
      formData.append("department", this.department);
      formData.append("position", this.position);
      formData.append("salary", this.salary);
      formData.append("cardnumber", this.cardnumber);
      let url = "/addstaffmember";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStaffMembers();
          this.$bvModal.hide("new-staffmember");
          this.fullname = "";
          this.contact = "";
          this.email = "";
          this.address = "";
          this.position = "";
          this.nin = "";
          this.salary = "";
        }
      });
    },
    async editStaffMemberPassword() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("username", this.username);
      formData.append("password", this.password);
      formData.append("role", this.role);
      let url = "/enrollstaffmember";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStaffMembers();
          this.$bvModal.hide("enroll-staffmember");
        }
      });
    },
    async editStaffMember() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("fullname", this.fullname);
      formData.append("contact", this.contact);
      formData.append("email", this.email);
      formData.append("gender", this.gender);
      formData.append("address", this.address);
      formData.append("dateofbirth", this.dateofbirth);
      formData.append("nin", this.nin);
      formData.append("department", this.department);
      formData.append("position", this.position);
      formData.append("salary", this.salary);
      formData.append("cardnumber", this.cardnumber);
      let url = "/updatestaffmember";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStaffMembers();
          this.$bvModal.hide("edit-staffmember");
          this.fullname = "";
          this.contact = "";
          this.email = "";
          this.nin = "";
          this.position = "";
          this.salary = "";
        }
      });
    },
    async removeStaffMember() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removestaffmember";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStaffMembers();
          this.$bvModal.hide("delete-staffmember");
        }
      });
    },
    async CheckPassword() {
      var strength = this.password.length;
      if (strength < 6) {
        this.passStrength = '<i class="text-danger small">Weak</i>';
        this.btnuser = true;
      } else {
        this.passStrength = '<i class="text-success small">Strong</i>';
        this.btnuser = false;
      }
    },
    async CheckUsername() {
      let formData = new FormData();
      formData.append("username", this.username);
      let url = "/checkusername";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          if (response.data == 1) {
            this.usernameerror =
              '<i class="text-danger small">Username Already Taken</i>';
            this.btnuser = true;
          } else {
            this.usernameerror = "";
            this.btnuser = false;
          }
        }
      });
    },
  },
};
</script>
